import { Drawer, Divider } from 'antd';
import topicos from "../../data/json/politica.json";

const PoliticaPrivacidade = ({ open, setOpen }) => {

    const onClose = () => setOpen(false);

    const renderContent = (item) => {
        const { text, subtitle } = item;

        return (
            <div style={{ marginBottom: 16 }}>
                {subtitle && (
                    <p style={{
                        fontWeight: 500,
                        marginBottom: 8,
                        color: '#555'
                    }}>
                        {subtitle}
                    </p>
                )}

                {Array.isArray(text) ? (
                    <ol style={{
                        paddingLeft: 20,
                        lineHeight: 1.7,
                        color: '#444'
                    }}>
                        {text.map((subItem) => (
                            <li key={subItem.id} style={{ marginBottom: 6 }}>
                                {subItem.title && (
                                    <strong>{subItem.title}: </strong>
                                )}
                                {subItem.description}
                            </li>
                        ))}
                    </ol>
                ) : (
                    <p style={{ lineHeight: 1.7, color: '#444' }}>
                        {text}
                    </p>
                )}
            </div>
        );
    };

    return (
        <Drawer
            title="Política de Privacidade"
            onClose={onClose}
            open={open}
            width={700}
            bodyStyle={{
                padding: '24px 32px',
                background: '#fafafa'
            }}
        >   
         {/* 🔹 Texto isolado */}
            {topicos.title && (
                <>
                    <h1 style={{ fontSize: 16, fontWeight: 600, color: "blue" }}>
                        {topicos.title_principal}
                    </h1>

                    <p>
                        <strong>{topicos.sub}</strong>
                    </p>

                    <p>
                        {topicos.description}
                    </p>

                    <p>
                        <strong>{topicos.text}</strong>
                    </p>
                    <Divider />
                </>
            )}

            <ul>
                {topicos.list.map((item, index) => {
                    return(
                        <li key={index}><p>{item.id} - {item.description}</p></li>
                    )
                })}
            </ul>

            {/* 🔹 Seção principal */}
            {topicos.politicas.map((item, index) => (
                <div key={`p1-${item.id}`} style={{ marginBottom: 24 }}>
                    
                    <h3 style={{
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#1a1a1a',
                        marginBottom: 8
                    }}>
                        {index + 1}. {item.title}
                    </h3>

                    {renderContent(item)}

                    <Divider />
                </div>
            ))}

            {/* 🔹 Texto isolado */}
            {topicos.title && (
                <>
                    <h3 style={{ fontSize: 16, fontWeight: 600, color: "blue" }}>
                        {topicos.politicas.length + 1}. {topicos.title}
                    </h3>
                    <Divider />
                </>
            )}

            {/* 🔹 Segunda seção */}
            {topicos.politica_2?.map((item, index) => (
                <div key={`p2-${item.id}`} style={{ marginBottom: 24 }}>
                    
                    <h3 style={{
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#1a1a1a',
                        marginBottom: 8
                    }}>
                        {topicos.politicas.length + index + 2}. {item.title}
                    </h3>

                    {renderContent(item)}

                    <Divider />
                </div>
            ))}

            {/* 🔹 Texto isolado */}
            {topicos.title_1 && topicos.title_2 && (
                <>
                    <h3 style={{ fontSize: 16, fontWeight: 600, color: "blue" }}>
                        <p>{topicos.title_1}</p>
                        <p>{topicos.title_2}</p>
                    </h3>
                    <Divider />
                </>
            )}


            {/* 🔹 Terceira seção */}
            {topicos.politica_3?.map((item, index) => (
                <div key={`p2-${item.id}`} style={{ marginBottom: 24 }}>
                    
                    <h3 style={{
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#1a1a1a',
                        marginBottom: 8
                    }}>
                        {topicos.politicas.length + index + 2}. {item.title}
                    </h3>

                    {renderContent(item)}

                    <Divider />
                </div>
            ))}
        </Drawer>
    );
};

export default PoliticaPrivacidade;